import React, { useState, useEffect } from "react";
import {
  Typography,
  Modal,
  Box,
  ImageListItem,
  Divider,
  Button,
  Grid,
  Stack,
  TextField,
  Select,
} from "@mui/material";
import Close from "../../assets/icons/Close.svg";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import ImageZoomModal from "../../components/Defects/DefectDetails/ImageZoomModal";
import CircularProgress from "@mui/material/CircularProgress";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ReactAudioPlayer from "react-audio-player";
import ship1 from "../../assets/images/ship1.png";
import { getRepairDefectsDetailsByIdList } from "../../redux/actions/repairsAction";
import GenerateRepairId from "../../utils/GenerateRepairId";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "55%",
  bgcolor: "background.paper",
  border: "1px solid #FFFFFF",
  boxShadow: 24,
  padding: "20px 0px 20px 0px",
  borderRadius: "12px",
  outline: "none",
  height: "54rem",
  overflowY: "auto",
  "&::-webkit-scrollbar": {
    width: "5px",
    height: "3px",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#20724E",
    borderRadius: "4px",
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#E5F1EB",
  },
  "@media (max-width: 1440px)": {
    width: "92%",
    height: "80vh",
  },
};

const labelstyle = {
  fontSize: "14px",
  fontWeight: "600",
  color: "#464E5F",
  fontSize: "14px",
  fontWeight: "600",
  color: "#464E5F",
};

const inputStyle = {
  fontSize: "14px",
  fontWeight: "400",
  color: "#464E5F",
  marginLeft: "5px",
  fontSize: "14px",
  fontWeight: "400",
  color: "#464E5F",
  marginLeft: "5px",
};

const RepairsViewModel = (Props) => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state?.user?.isLoading);
  const currentYear = new Date().getFullYear();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [selectedImages, setSelectedImages] = useState([]);
  const [expanded, setExpanded] = useState([]);

  const handleImageSelection = (event) => {
    const files = event.target.files;
    if (files.length === 0) return;
    const newImages = Array.from(files)
      .slice(0, 100)
      .map((file) => URL.createObjectURL(file));
    setSelectedImages((prevImages) => [...prevImages, ...newImages]);
  };

  const openModal = (image) => {
    if (image) {
      setSelectedImage(image);
      setIsModalOpen(true);
    }
  };

  const closeModal = () => {
    setSelectedImage(null);
    setIsModalOpen(false);
  };

  const toggleAccordion = (index) => {
    const newExpanded = [...expanded];
    newExpanded[index] = !newExpanded[index];
    setExpanded(newExpanded);
  };

  const RepairDeffectlist = useSelector(
    (state) => state?.repairs?.repairsdefectstDetailsData
  );

  useEffect(() => {
    dispatch(
      getRepairDefectsDetailsByIdList({
        id: Props?.repairDeffectRowData?.id,
      })
    );
  }, []);

  return (
    <Modal
      open={Props.isRepairsViewModel}
      onClose={() => Props.handleCloseRepairsViewModel}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box
          sx={{
            display: "flex",
            marginBottom: "20px",
            // overflow: "",
          }}
        >
          <Box sx={{ width: "90%" }}>
            <Typography
              align="center"
              sx={{
                color: "#212121",
                fontSize: "22px",
                fontWeight: 500,
                position: "relative",
                left: "50px",
              }}
            >
              Repair View
            </Typography>
          </Box>
          <Box
            sx={{
              width: "10%",
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
              mr: 3,
            }}
          >
            <ImageListItem
              sx={{
                cursor: "pointer",
                width: "15px",
              }}
              onClick={Props.handleCloseRepairsViewModel}
            >
              <img src={Close} alt="" />
            </ImageListItem>
          </Box>
        </Box>
        <Divider />
        <Box sx={{ padding: "25px 25px 25px 25px" }}>
          <Grid
            container
            rowSpacing={1}
            columnSpacing={1}
            spacing={{ xs: 1, sm: 2, md: 3 }}
            pb={3}
          >
            <Grid item xs={12} sm={6} md={4}>
              <Box
                sx={{
                  backgroundColor: "#F3F6F9",
                  padding: "15px",
                  borderRadius: "10px",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Typography sx={labelstyle}>Repair ID:</Typography>
                <Typography sx={inputStyle}>
                  {GenerateRepairId(
                    Props?.repairDeffectRowData?.check_list_type_info
                      ?.vessel_info?.name,
                    Props?.repairDeffectRowData?.display_id
                  )}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
              <Box
                sx={{
                  backgroundColor: "#F3F6F9",
                  padding: "15px",
                  borderRadius: "10px",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Typography sx={labelstyle}>Department:</Typography>
                <Typography sx={inputStyle}>
                  {Props?.repairDeffectRowData?.checklist?.department?.name}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={12} md={4}>
              <Box
                sx={{
                  backgroundColor: "#F3F6F9",
                  padding: "15px",
                  borderRadius: "10px",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Typography sx={labelstyle}>Vessel Name:</Typography>
                <Typography sx={inputStyle}>
                  {
                    Props?.repairDeffectRowData?.check_list_type_info
                      ?.vessel_info?.name
                  }
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  backgroundColor: "#F3F6F9",
                  padding: "15px",
                  borderRadius: "10px",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Typography sx={labelstyle}>Created Date & Time :</Typography>
                <Typography sx={inputStyle}>
                  {moment(Props?.repairDeffectRowData?.createdAt).format(
                    "D MMMM, YYYY | hh:mm A"
                  )}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} md={6}>
              <Box
                sx={{
                  backgroundColor: "#F3F6F9",
                  padding: "15px",
                  borderRadius: "10px",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <Typography sx={labelstyle}>Submitted Date & time :</Typography>
                <Typography sx={inputStyle}>
                  {moment(Props?.repairDeffectRowData?.updatedAt).format(
                    "D MMMM, YYYY | hh:mm A"
                  )}
                </Typography>
              </Box>
            </Grid>
          </Grid>

          <Divider />
          <Box
            sx={{
              display: "flex",
              padding: "20px 10px 20px 10px",
            }}
          >
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: "600",
                  color: "#B5B5C3",
                }}
              >
                Repair
              </Typography>
            </Box>
          </Box>
          <Divider />
          <Box pt={1}>
            <Grid
              sx={{
                overflow: "auto",
                height: "32rem",
                padding: "0px 10px 0px 10px",
                "&::-webkit-scrollbar": {
                  width: "5px",
                  height: "3px",
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#20724E",
                  borderRadius: "4px",
                },
                "&::-webkit-scrollbar-track": {
                  backgroundColor: "#E5F1EB",
                },
              }}
            >
              {isLoading ? (
                <Grid item xs={12}>
                  <Stack
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "100%",
                      height: "32rem",
                    }}
                  >
                    <CircularProgress color="success" />
                  </Stack>
                </Grid>
              ) : (
                <Grid item xs={12}>
                  <Stack direction="row" alignItems="center">
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        width: "100%",
                        padding: "10px 0px 0px 0px",
                        cursor: "pointer",
                      }}
                    >
                      <Box>
                        <Typography
                          align="center"
                          sx={{
                            fontSize: "14px",
                            color: "#464E5F",
                            fontWeight: 600,
                          }}
                        >
                          {RepairDeffectlist?.question?.question}
                        </Typography>
                      </Box>
                      <Box>
                        <Button
                          sx={{
                            border: "1px solid #FFE2E5",
                            fontSize: "15px",
                            fontWeight: 600,
                            width: "6rem",
                            backgroundColor: "#FFE2E5",
                            borderRadius: "10px",
                            textTransform: "capitalize",
                            color: "#FF4646",
                            ":hover": {
                              backgroundColor: "#FFE2E5",
                              border: "#FFE2E5",
                            },
                          }}
                          variant="outlined"
                        >
                          Repairs
                        </Button>
                      </Box>
                    </Box>
                  </Stack>
                  <Box sx={{ marginTop: "20px" }}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "20px",
                        justifyContent: "space-between",
                        "@media (max-width: 768px) and (max-height: 909px)": {
                          flexDirection: "column",
                        },
                      }}
                    >
                      <Box
                        sx={{
                          backgroundColor: "#F3F6F9",
                          width: "100%",
                          padding: "15px",
                          borderRadius: "10px",
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: "600",
                            fontSize: "14px",
                            lineHeight: "21px",
                          }}
                        >
                          Voice Message
                        </Typography>
                        {RepairDeffectlist?.audio_file !== null ? (
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "left",
                              alignItem: "left",
                              padding: "10px",
                            }}
                          >
                            <ReactAudioPlayer
                              src={RepairDeffectlist?.audio_file} // Replace with your audio file URL
                              controls
                            />
                          </Box>
                        ) : (
                          <Box
                            sx={{
                              color: "#464E5F",
                              fontSize: "14px",
                              padding: "10px 10px 10px 0",
                              opacity: "0.6",
                            }}
                          >
                            Audio is not available
                          </Box>
                        )}
                      </Box>
                      <Box
                        sx={{
                          backgroundColor: "#F3F6F9",
                          width: "100%",
                          padding: "15px",
                          borderRadius: "10px",
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <Typography
                          sx={{
                            fontWeight: "600",
                            fontSize: "14px",
                            lineHeight: "21px",
                          }}
                        >
                          Attachment by Vessel
                        </Typography>
                        {RepairDeffectlist?.file?.length !== 0 ? (
                          <Box
                            sx={{
                              display: "flex",
                              gap: "10px",
                              padding: "5px 5px 5px 5px",
                            }}
                          >
                            {RepairDeffectlist?.file?.map((image, index) =>
                              image?.contentType !== "application/pdf" ? (
                                <Box
                                  key={index}
                                  component="img"
                                  sx={{
                                    height: 70,
                                    width: 70,
                                    borderRadius: "10px",
                                    maxHeight: { xs: 233, md: 167 },
                                    maxWidth: { xs: 350, md: 250 },
                                  }}
                                  alt="Attachment is not available"
                                  src={image?.URL}
                                  onClick={() => openModal(image?.URL)}
                                />
                              ) : (
                                <Box
                                  key={index}
                                  sx={{
                                    position: "relative",
                                    overflow: "hidden",
                                    borderRadius: "10px",
                                  }}
                                >
                                  <a
                                    href={image?.URL}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      width: "70px",
                                      height: "70px",
                                      borderRadius: "10px",
                                    }}
                                  >
                                    <PictureAsPdfIcon />
                                  </a>
                                </Box>
                              )
                            )}
                          </Box>
                        ) : (
                          <Typography
                            sx={{
                              color: "#464E5F",
                              fontSize: "14px",
                              padding: "10px 10px 10px 0",
                              opacity: "0.6",
                            }}
                          >
                            Attachment is not available
                          </Typography>
                        )}
                      </Box>
                    </Box>
                    <Box
                      sx={{
                        marginTop: "20px",
                        backgroundColor: "#F3F6F9",
                        borderRadius: "10px",
                      }}
                    >
                      <TextField
                        placeholder="Remarks:"
                        value={
                          RepairDeffectlist?.remark
                            ? RepairDeffectlist?.remark
                            : "Not-Available"
                        }
                        disabled
                        sx={{
                          width: "100%",
                          borderRadius: "10px",
                          backgroundColor: "#F3F6F9",
                          border: "none",
                          "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                            border: "0px solid #F3F6F9",
                            borderRadius: "10px",
                          },
                          "& .MuiOutlinedInput-notchedOutline": {
                            border: "none",
                          },
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </Box>
                  </Box>
                </Grid>
              )}
            </Grid>
          </Box>
        </Box>
        <ImageZoomModal
          sx={{
            width: "50%",
            height: "100%",
            objectfit: "contain",
            backgroundColor: "white",
          }}
          isOpen={isModalOpen}
          onRequestClose={closeModal}
          src={selectedImage}
          alt="Attachment is not available"
        />
      </Box>
    </Modal>
  );
};

export default RepairsViewModel;
